import { useTranslation } from 'react-i18next';

import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs';
import { useGlobal } from '~/hooks/useGlobal';
import type { BreadcrumbsItem } from '~/stores/CatalogStore';

import MobileHeaderLayout from '../../Main/MobileHeader/MobileHeaderLayout';
import MobileHeaderTitle from '../../Main/MobileHeader/MobileHeaderTitle';

import tp from '../textPage.module.scss';
import styles from './AboutPage.module.scss';

const ADVANTAGES_RU = [
  'Работаем с 2015 года',
  'Более 100 000 доставленных заказов',
  'Проверка подлинности каждого товара',
  'Фирменная упаковка с защитными элементами',
  'Официальные поставщики премиум-брендов',
];

const ADVANTAGES_EN = [
  'Operating since 2015',
  'Over 100,000 orders delivered',
  'Authenticity verification for every item',
  'Branded packaging with security features',
  'Official suppliers of premium brands',
];

const content = {
  ru: {
    advantages: ADVANTAGES_RU,
    intro1:
      'Dubai Express — надёжный сервис доставки оригинальных товаров из Дубая. Работаем с 2015 года, доставили более 100 000 заказов в Россию.',
    intro2:
      'Каждый товар проходит проверку подлинности на нашем складе в Дубае. Сотрудничаем только с официальными дистрибьюторами и авторизованными магазинами премиум-брендов.',
    missionTitle: 'Наша миссия',
    missionText:
      'Делать премиум-товары из Дубая доступными для покупателей в России с гарантией оригинальности и прозрачными условиями доставки.',
    trustTitle: 'Почему нам доверяют',
  },
  en: {
    advantages: ADVANTAGES_EN,
    intro1:
      'Dubai Express is a trusted delivery service for authentic goods from Dubai. Operating since 2015, we have delivered over 100,000 orders worldwide.',
    intro2:
      'Every item undergoes authenticity verification at our warehouse in Dubai. We work exclusively with official distributors and authorized premium brand stores.',
    missionTitle: 'Our Mission',
    missionText:
      'To make premium goods from Dubai accessible to customers worldwide with guaranteed authenticity and transparent delivery terms.',
    trustTitle: 'Why Customers Trust Us',
  },
};

const AboutPage = () => {
  const { t, i18n } = useTranslation();
  const { isTablet } = useGlobal();

  const lang = i18n.language.startsWith('ru') ? 'ru' : 'en';
  const c = content[lang];

  return (
    <>
      <MobileHeaderLayout content={<MobileHeaderTitle text={t('aboutUs')} />} />
      <div className="content-layout">
        <div className={tp.root}>
          {!isTablet && (
            <Breadcrumbs
              items={
                [
                  { text: t('home'), link: '/' },
                  { text: t('aboutUs'), link: '/about' },
                ].filter(Boolean) as BreadcrumbsItem[]
              }
            />
          )}

          <div className={tp.content}>
            <h1 className={tp.title}>{t('aboutUs')}</h1>

            <section className={tp.section}>
              <p className={tp.text}>{c.intro1}</p>
              <p className={tp.text}>{c.intro2}</p>
            </section>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.missionTitle}</h2>
              <p className={tp.text}>{c.missionText}</p>
            </section>

            <section className={tp.section}>
              <h2 className={tp.subtitle}>{c.trustTitle}</h2>
              <ul className={styles.advantages}>
                {c.advantages.map((text) => (
                  <li key={text} className={styles.advantageItem}>
                    {text}
                  </li>
                ))}
              </ul>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
